import { ReactNode, useEffect } from "react";
import { ButtonComponent } from "../../button";
import { Colors, IconStyle, Size, Variant } from "../../button/dto";
import { HeadingComponent } from "../../heading";
import { HeadingSize } from "../../heading/dto";
import { PlusIcon } from "../../icons/plus";
import { TrashIcon } from "../../icons/trash";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { SpinnerComponent } from "../../spinner";
import { SwitchComponent } from "../../switch";
import { TextInput } from "../../textInput";
import colors from '../../utils/index.module.scss';
import { setSalesRegisters, setSalesRegistersNumber } from "../slice";

interface Props {
    disabled: boolean
}

export function SalesRegister(props: Props) {
    const { disabled } = props
    const companyState = useAppSelector(state => state.company)
    const dispatch = useAppDispatch()

    const salesRegister = companyState.findCompanyResponse?.salesRegister
    const salesRegisterRequest = companyState.companyRegistryDTO.salesRegister

    useEffect(() => {
        if (companyState.findCompanyStatus === 'successfully' && companyState.findCompanyResponse !== undefined) {
            if (salesRegister === undefined || salesRegister === null || salesRegister.length === 0) {
                dispatch(setSalesRegisters(['']))
                dispatch(setSalesRegistersNumber(0))
            } else {
                dispatch(setSalesRegisters(salesRegister))
                dispatch(setSalesRegistersNumber(salesRegister.length))
            }
        }
    }, [salesRegister, companyState.findCompanyStatus, companyState.findCompanyResponse])

    let registers: ReactNode[] = []
    if (salesRegisterRequest !== undefined && salesRegisterRequest !== null && salesRegisterRequest.length > 0) {
        salesRegisterRequest.forEach((sale, index) => {
            registers.push(
                <div
                    key={'sale-register-' + index}
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 24
                    }}
                >
                    <TextInput
                        id={"sale-register-input-" + index}
                        type={"text"}
                        disabled={disabled}
                        placeholder={"Inserire nome registro"}
                        value={salesRegisterRequest[index].split('::')[0]}
                        onChange={(e) => {
                            const newRegister = [...salesRegisterRequest]
                            newRegister[index] = e.target.value + (salesRegisterRequest[index].split('::')[1] !== undefined ? "::estero" : '')
                            dispatch(setSalesRegisters(newRegister))
                        }}
                    />
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8 }}>
                        <SwitchComponent
                            disabled={disabled}
                            checked={salesRegisterRequest[index].split('::').length === 2}
                            onChange={(e) => {
                                if (e.target.checked) {
                                    const newRegister = [...salesRegisterRequest]
                                    newRegister[index] = salesRegisterRequest[index].concat('::estero')
                                    dispatch(setSalesRegisters(newRegister))
                                } else {
                                    const newRegister = [...salesRegisterRequest]
                                    newRegister[index] = salesRegisterRequest[index].split('::')[0]
                                    dispatch(setSalesRegisters(newRegister))
                                }
                            }}
                        />
                        <span className="text text--md typography--medium typography-neutral--500">Estero</span>
                    </div>
                    <ButtonComponent
                        label={""}
                        disabled={disabled}
                        onClick={() => {
                            let newSales = [...salesRegisterRequest]
                            newSales = newSales.slice(0, index).concat(newSales.slice(index + 1));
                            dispatch(setSalesRegisters(newSales.length === 0 ? [""] : newSales))
                            dispatch(setSalesRegistersNumber(newSales.length))
                        }}
                        color={Colors.PRIMARY}
                        variant={Variant.LINK}
                        size={Size.SM}
                        iconStyle={IconStyle.ONLY}
                        icon={<TrashIcon colorBase={colors.primary500} />}
                    />
                </div>
            )
        })
    }

    return (
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <HeadingComponent size={HeadingSize.SM} label={"Registro Vendite"} buttons={[
                <ButtonComponent
                    disabled={salesRegisterRequest.length >= 5 || disabled}
                    label={"Aggiungi registro"}
                    icon={<PlusIcon colorBase={""} />}
                    onClick={() => {
                        const newSales = [...salesRegisterRequest]
                        newSales.push('')
                        dispatch(setSalesRegisters(newSales))
                        dispatch(setSalesRegistersNumber(newSales.length))
                    }}
                    color={Colors.PRIMARY}
                    variant={Variant.OUTLINE}
                    size={Size.SM}
                    iconStyle={IconStyle.LEFT}
                />
            ]}
            />
            {registers}
        </div>
    )
}